import { ReceiptRoot } from 'lib';

export const styles = {
    drawer: {
        '& .MuiPaper-root': {
            borderTopLeftRadius: '40px',
        },
    },
    drawerCloseButton: { ml: 'auto', mr: 4, mt: 4 },
    contentContainer: { mx: 6, width: '600px' },
    contentWrapper: { mb: 1 },
    consoleWrapper: { p: 1 },
    consoleContainer: {
        backgroundColor: 'black',
        color: 'white',
        maxHeight: '300px',
        p: 1,
        overflowWrap: 'anywhere',
        overflow: 'scroll',
    },
};

export type Anchor = 'top' | 'left' | 'bottom' | 'right';

export interface ReceiptDrawerProps {
    selectedReceipt?: ReceiptRoot;
    setSelectedReceipt: Function;
    chainType?: string;
}
